$(document).ready(function(){
  //console.log('hi custom');
  if($('body').hasClass('template-index')){
    $('body').find('.faq-part .faq-wrap .faq-1').trigger('click');
  }
  
  $(".dd-selected img").on("error", function () {
    $(this).css("display", "none");
  });
  $(".dd-options img").on("error", function () {
    $(this).css("display", "none");
  });
  
  
  
//   $("select.ddslick").each(function(){
//         var name =  $(this).attr('name');
//         var id = $(this).attr('id');
//     console.log(id);
//         $("#"+id).ddslick({
//             showSelectedHTML: false,
//             onSelected: function(selectedData){
//               var value = $('.dd-selected-value').val();
//               console.log();
//                 $("#"+id+ " .dd-selected-value").prop('name', name);
//               $('select.'+id).find('option[value="'+value+'"]').prop('selected', true);
//              }  
//         });
//     });

function update_dropdowns(selected_op){
  // console.log("update_dropdowns");
  
  // All variantJson 
  var variantJson = document.querySelector("[data-variant-json]");
  var dd_variants = JSON.parse(variantJson.innerHTML);    
  
  
  if (!variantJson) {
    return;
  }
  setTimeout(function () {
    $('.variant-input-wrap[data-index="option2"] li .dd-option .dd-option-value').parents('li').show();
    $.each(dd_variants, function(i, dd_variant) {
      if(!dd_variant.available){
        // console.log(dd_variant);
        
        var opt_1 = dd_variant.option1;
        var opt_2 = dd_variant.option2;
          
        // Option1
        if($('.variant-input-wrap[data-index="option1"] li').length){
            $('.variant-input-wrap[data-index="option1"] li').each(function(i, obj) {
                if($(this).find('.dd-option .dd-option-value').val() == dd_variant.option1){
                     $(this).hide();
                  }else{
                      $(this).show();
                  }
              });                    
          if(opt_1 == selected_op){
            // console.log("OPT_2======"+opt_2);
            $('.variant-input-wrap[data-index="option2"] li .dd-option .dd-option-value[value="'+opt_2+'"]').parents('li').hide();
           
            
            // $('.variant-input-wrap[data-index="option2"] .dd-select').trigger("click");
            // var new_selected_opt = $('.variant-input-wrap[data-index="option2"] ul').find("li").not(":hidden").first().find(".dd-option .dd-option-value").val();
            
            var new_dd_selected_opt;
            $('.variant-input-wrap[data-index="option2"] li').each(function(i, obj) {
                if($(this).css('display') != 'none'){
                    console.log($(this).find("input").val());
                    new_dd_selected_opt = $(this).find("input").val();
                    return false;
                }
            });  
            
            // console.log("new_selected_opt ==>"+new_selected_opt);
            $('.variant-input-wrap[data-index="option2"] li .dd-option .dd-option-value[value="'+new_dd_selected_opt+'"]').parents('a').trigger('click');
          }
        }
      }
    });
    var curr_var = '';
    $('.variant-input-wrap .dd-select').each(function(i, obj) {
    var ms = $(this).find("input.dd-selected-value").val();   
    curr_var+= ms + ' / ';
    });     
    curr_var = curr_var.slice(0, -2);
    curr_var = curr_var.trim();
    
    
    // console.log("selected Var = > "+ curr_var);
    $('select[name="id"] option[data-val="'+curr_var+'"]').prop('selected',true);
    $('select[name="id"]').trigger('change');
  }, 500);
    
}
  
  $('.chosen_farbe').ddslick({
    onSelected: function(selectedData){
      //callback function: do something with selectedData;
      
      var value = $('.dd-selected-value').val();
      
      // console.log("color changed");
      // update_dropdowns(value);
      $(".dd-selected img").on("error", function () {
        $(this).css("display", "none");
      });
      $(".dd-options img").on("error", function () {
        $(this).css("display", "none");
      });
    
      // var value = $('.dd-selected-value').val();
      // console.log(value);
      // var op_name = $('.dd-selected-value').parent('.dd-select').parents('.variant-input-wrap').data('option');
      // console.log(op_name);
    
      var curr_var = '';
      $('.variant-input-wrap .dd-select').each(function(i, obj) {
      var ms = $(this).find("input.dd-selected-value").val();   
          curr_var+= ms + ' / ';
      });     
      curr_var = curr_var.slice(0, -2);
      curr_var = curr_var.trim();
      // console.log("selected Var = > "+ curr_var);
      $('select[name="id"] option[data-val="'+curr_var+'"]').prop('selected',true);
      $('select[name="id"]').trigger('change');
    }
  });
  // console.log("chosen_other",$('.chosen_other'));
  
  $('.chosen_other').ddslick({
    onSelected: function(selectedData){
      // callback function: do something with selectedData;
      // console.log("selectedData",selectedData,$(this));
      // var value = $('.dd-selected-value').val();
      var value = selectedData.selectedData.value;
      // console.log(value);
      // console.log('chosen_other =>'+value);
      update_dropdowns(value);
      
      var curr_var = '';
      $('body').find('.select_option').each(function(){
        var hh = $(this).find('option:selected').text();
        if(hh != ""){
          // console.log("hh",hh);
          // console.log("opt",$(this).find('option[value="'+value+'"]'));
          $(this).find('option[value="'+value+'"]').removeAttr("disabled");
          // $(this).find('option[value="'+value+'"]').attr("selected","true");
          // $(this).find('option[value="'+value+'"]').prop("selected",true);
          let selectEl = $(this).find('option[value="'+value+'"]').parents("select")[0];
          if(selectEl){
            // console.log("selectEl",selectEl);
            selectEl.value = value;
            selectEl.dispatchEvent(new Event('change'));
            // $(this).find('option[value="'+value+'"]').trigger('change');
            // console.log("select",$(this).find('option[value="'+value+'"]').parents("select").val());
          }
          var gg = $(this).find('option:selected').text();
          // console.log(gg);
          curr_var+= gg + ' / ';
        }
      });
      
      // console.log('111curr_var => ',curr_var);
      
      curr_var = curr_var.slice(0, -2);
      curr_var = curr_var.trim();
      
      // console.log('222curr_var=>',curr_var);
      
      $('select[name="id"] option[data-val="'+curr_var.trim()+'"]').prop('selected',true);
      //$("select[name="id"] option[data-val="+curr_var.trim()+"]").prop('selected',true);
      $('select[name="id"]').trigger('change');
    }   
  });



//   $('.filter-form .collection_sidebar_group').click(function(e){
//     e.preventDefault();
//     $('.collapsible-trigger').removeClass('is-open');
//     $('.collapsible-content').removeClass('is-open');
    
//     $(this).addClass('is-open');
//     $(this).next().addClass('is-open');
    
//   })
  
  
  // Open Filters in mobile
  if( $(window).width() < 768 ){
    $('#FilterDrawer .filter-form .collection_sidebar_group').each(function(){
      // console.log($(this).find('.collapsible-trigger').trigger('click'));
    });
  }

  $(document).on("click", "body", function(t) {
    $(t.target).is(".collapsible-trigger, .collapsible-trigger__icon .icon, .collapsible-content, .js-drawer-open-collection-filters, .collection-filter__item")? $(".collapsible-trigger").removeClass(""):$('#CollectionSidebar .collapsible-trigger, #CollectionSidebar .collapsible-content').removeClass("is-open")
  });

// // Current Variant 
// var currentVariantJson = document.querySelector("[data-current-variant-json]");
// var dd_current_variant = JSON.parse(currentVariantJson.innerHTML);
//     // All variantJson 
// var variantJson = document.querySelector("[data-variant-json]");
// var dd_variants = JSON.parse(variantJson.innerHTML);
        
//         if (!variantJson) {
//           return;
//         }
// $.each(dd_variants, function(i, dd_variant) {
//       if(!dd_variant.available){
        
//         setTimeout(function () {
//           var opt_1 = dd_variant.option1;
//           var opt_2 = dd_variant.option2;
            
//             // Option1
//             if($('.variant-input-wrap[data-index="option1"] li').length){
//               $('.variant-input-wrap[data-index="option1"] li').each(function(i, obj) {
//                   if($(this).find('.dd-option .dd-option-value').val() == dd_variant.option1){
//                        $(this).hide();
//                     }
//                 });
//             }

//             // Option2
//             if($('.variant-input-wrap[data-index="option2"] li').length){
//               $('.variant-input-wrap[data-index="option2"] li').each(function(i, obj) {
//                   if(opt_1 == dd_current_variant.option1 && $(this).find('.dd-option .dd-option-value').val() == dd_variant.option2){
//                        $(this).hide();
//                     }
//                 });
//             }

//         }, 2500);
            
//       }
//   });

 initSlider();
});
function initSlider(){
 $('.smoothie-cross-section .featured-collection-prodcuts').slick({
          dots: false,
          arrows: true,
          infinite: false,
          adaptiveHeight: true,
          autoplay: false, 
          autoplaySpeed: 6000,
          slidesToShow: 2,
          slidesToScroll: 1,
          nextArrow: '<svg class="slick-next slick-arrow" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg>',
          prevArrow: '<svg class="slick-prev slick-arrow" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg>',
         responsive: [
          {
            breakpoint: 769,
            settings: {
                dots: true,
                arrows: false
            }
          },
            {
            breakpoint: 600,
            settings: {
              centerMode: true,
              slidesToShow: 1,
              infinite: true,
               autoplay: true, 
               dots: true,
                arrows: false,
               centerPadding:'20px'
            }
          }
    ]
}); 

}


